var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail-container"},[_c('img',{staticClass:"thumbnail-img",attrs:{"src":_vm.img,"alt":_vm.altText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }